import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
export const CallToAction = () => {
  return <section className="mb-10" data-id="element-62">
      <h2 className="text-xl font-bold text-blue-800 mb-6 text-center" data-id="element-63">
        Start vandaag nog met Liefdevol Communiceren
      </h2>

      <div className="w-full mb-6" data-id="element-64">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2FwYxJVjG6C7aeyL5JTuqC/Scherm_afbeelding_2025-08-15_om_15.56.55-min.png" alt="Vrouw communiceert met haar hond in een gezellige woonkamer" className="w-full h-auto rounded-lg shadow-md" data-id="element-65" />
        <p className="text-xs text-gray-500 mt-1 text-center italic" data-id="element-66">
          De diepe band die mogelijk is wanneer je elkaar écht begrijpt
        </p>
      </div>

      <div className="bg-blue-50 p-6 rounded-lg border border-blue-200 mb-6" data-id="element-67">
        <h3 className="text-lg font-bold text-blue-800 mb-4" data-id="element-68">
          Je krijgt direct toegang tot:
        </h3>
        <ul className="space-y-3 mb-6" data-id="element-69">
          <li className="flex items-start" data-id="element-70">
            <CheckCircleIcon className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-71" />
            <span data-id="element-72">Module 1: Tools voor het dagelijks leven</span>
          </li>
          <li className="flex items-start" data-id="element-73">
            <CheckCircleIcon className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-74" />
            <span data-id="element-75">Module 2: Sociale Vaardigheden — Omgangsregels</span>
          </li>
          <li className="flex items-start" data-id="element-76">
            <CheckCircleIcon className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-77" />
            <span data-id="element-78">Module 3: Sociale Vaardigheden — Tafelmanieren</span>
          </li>
          <li className="flex items-start" data-id="element-79">
            <CheckCircleIcon className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-80" />
            <span data-id="element-81">Module 4: Sociale Vaardigheden — Jouw reactie</span>
          </li>
          <li className="flex items-start" data-id="element-82">
            <CheckCircleIcon className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-83" />
            <span data-id="element-84">Module 5: Attentie Signaal</span>
          </li>
          <li className="flex items-start" data-id="element-85">
            <CheckCircleIcon className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-86" />
            <span data-id="element-87">Module 6: Handgebaar</span>
          </li>
          <li className="flex items-start" data-id="element-88">
            <CheckCircleIcon className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-89" />
            <span data-id="element-90">Bonus Masterclass "Honden Geschiedenis"</span>
          </li>
          <li className="flex items-start" data-id="element-91">
            <CheckCircleIcon className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-92" />
            <span data-id="element-93">8 printbare stappenplannen</span>
          </li>
          <li className="flex items-start" data-id="element-94">
            <CheckCircleIcon className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-95" />
            <span data-id="element-96">Levenslange, onbeperkte toegang</span>
          </li>
        </ul>

        <a href="https://stresslessdogs.nl/lc-fb-adv2" className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-4 px-4 rounded-lg transition duration-200 block text-center mb-4 text-lg" target="_blank" rel="noopener noreferrer" data-id="element-97">
          → JA, IK WIL MIJN HOND EINDELIJK BEGRIJPEN ←
        </a>

        <p className="text-center text-sm text-gray-600" data-id="element-98">
          Direct toegang • Op je eigen tempo • Levenslang beschikbaar
        </p>
      </div>

      <h2 className="text-xl font-bold text-blue-800 mb-6 text-center" data-id="element-99">
        Klaar om de taalbarrière te doorbreken?
      </h2>

      <p className="text-center mb-6 leading-relaxed" data-id="element-100">
        Start vandaag met Liefdevol Communiceren en bouw de band op die jullie
        beiden verdienen.
      </p>

      <a href="https://stresslessdogs.nl/lc-fb-adv2" className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-4 px-4 rounded-lg transition duration-200 block text-center mb-4 text-lg animate-pulse" target="_blank" rel="noopener noreferrer" data-id="element-101">
        → JA, IK WIL MIJN HOND EINDELIJK BEGRIJPEN ←
      </a>

      <p className="text-center text-sm text-gray-600" data-id="element-102">
        Direct starten • Levenslange toegang
      </p>
    </section>;
};